(()=>{try{if(location.hostname==='shopify.fabric-market.com'&&location.pathname==='/'&&!location.search){location.replace('/?view=itd251');}}catch(e){}})();
/* itd-route-cache-asset-redirect 1783582764 */
(function() {
  try {
    var path = window.location.pathname.replace(/\/$/, '') || '/';
    var search = window.location.search || '';
    var refreshPaths = {
      '/': true,
      '/collections/all-launch-fabrics': true,
      '/collections/fabric-atlas-index': true,
      '/collections/modestwear-fabrics': true,
      '/collections/chanel-style-fabrics': true,
      '/collections/embroidery-fabrics': true,
      '/collections/womenwear-processed-fabrics': true,
      '/collections/check-stripe-fabrics': true,
      '/collections/jacquard-satin-fabrics': true,
      '/collections/lace-fabrics': true,
      '/collections/print-fabrics': true
    };
    if (refreshPaths[path] && search.indexOf('view=') === -1) {
      window.location.replace(window.location.pathname + '?view=itd251' + window.location.hash);
    }
  } catch (error) {}
})();
/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
